<div class="widget-categories widget-categories--location--{{ location }} widget">
    <h4 class="widget__title">{{ "categories" | translate}}</h4>
    <ul class="widget-categories__list" appCollapse>
        <li *ngFor="let category of categories" class="widget-categories__item" appCollapseItem="widget-categories__item--open" #collapse="appCollapseItem">
            <div class="widget-categories__row">
                <a *ngIf="category?.sectorData?.length" [routerLink]="['/sector', (category.sectorData[0]?.seo?.slug), 'category',  category?.seo?.slug]">
                    <div class="flex flex-row items-center">
                        <span>{{ translateHelper.localize(category.name) }}</span>
                        <app-icon class="widget-categories__arroww mx-1" name="arrow-rounded-right-6x9" size="6x9"></app-icon>
                    </div>
                </a>
                <!-- <button *ngIf="category.children?.length" class="widget-categories__expander" type="button" (click)="collapse.toggle()"></button> -->
            </div>
            <!-- <div *ngIf="category.children?.length" class="widget-categories__subs" appCollapseContent>
                <ul>
                    <li *ngFor="let sub of category.children"><a [routerLink]="['category', category.sectorData?.seo?.slug, category?.seo?.slug]">{{ sub.name }}</a></li>
                </ul>
            </div> -->
        </li>
    </ul>
</div>
